export default [
    {
        path: '/groups',
        name: 'groups',
        component: () => import('@/views/group-list/index.vue'),
        meta: {
            isSection: true
        }
    },
    {
        path: '/groups/add',
        name: 'groups_add',
        component: () => import('@/views/group-details/index.vue')
    },
    {
        path: '/groups/:uuid',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'groups_uuid',
                component: () => import('@/views/group-details/index.vue'),
                props: route => ({ id: route.params.uuid })
            },
            {
                path: 'edit',
                name: 'group_uuid_edit',
                component: () => import('@/views/group-details/index.vue')
            },
            {
                path: 'view',
                name: 'groups_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            }
        ]
    }
];
